import * as React from "react";
import locationIcon from "../../assets/images/icons/location.png";
import { useEffect, useState } from "react";
import ProjectService from "../project/ProjectService";
import { geocodePlaceId, getAllKitTypes, getCurrentLocation, getPlacePredictions, loadGoogleMaps } from "src/services/corporateService";
import { KitData } from "../polar-SAAS-Components/models-new";
import { environment } from "src/environments/environment";
import authService from 'src/app/polar-SAAS-Components/auth-service';
import useStyleClasses from "../polar-SAAS-Components/style";
import Loader from "../polar-SAAS-Components/components/Loader";


interface AddKitModalProps {
  showModal: boolean;
  handleClose: () => void;
  onCreateKit: (KitData) => Promise<void>;
  myLoc: { lat: number; lng: number } | null;
  setMyLoc: React.Dispatch<React.SetStateAction<{ lat: number; lng: number } | null>>;
  setShowMapModal: React.Dispatch<React.SetStateAction<boolean>>;
  error:string;
  setError:React.Dispatch<React.SetStateAction<string>>;

}

const AddKitModal: React.FC<AddKitModalProps> = ({
  showModal,
  handleClose,
  onCreateKit,
  myLoc,
  setMyLoc,
  setShowMapModal,
  error,
  setError

}) => {
  const isAddKitSAAS = React.useMemo(() => authService.isCorporateSAASAdmin(), []);
  const [formData, setFormData] = useState<KitData>({
    id:"",
    name: '',
    description: '',
    sensorMap: {},
    inputMethod: '',
    metaData: { area: '', item: '' },
    initialLocation: undefined as any,
    projectId: '',
    typeOfKit: '',
    brandModel: '',
    storageCategory: ''
  });
  const [projectsAll, setProjectsAll] = useState([]);
  const [typeOfKits, setTypeOfKits] = useState([]);
  const [sensors, setSensors] = useState([
    {
      "code": "T",
      "codeValue": "Temperature"
    },
    {
      "code": "H",
      "codeValue": "Humidity"
    }
  ]);
  const [kitId,setKitId]=useState("");
  const [sensorList, setSensorList] = useState([{ id: "0", sensor: "" }]);
  const [errors, setErrors] = useState({
    name: '',
    description: '',
    inputMethod: '',
    metaData: '',
    area: '',
    item: '',
    projectId: '',
    typeOfKit: '',
    sensorMap: '',
    storageCategory: '',
    id:''
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [predictions, setPredictions] = useState<any[]>([]);
  const [areaError, setAreaError] = useState("");
  const [loading,setLoading]=useState(false);

  const inputMethods =
    [
      { name: "Entry", value: 'MANUAL' ,isAllowed:true },
      { name: "Photo", value: 'IMAGE' ,isAllowed:environment.azure.planSnapId==authService.getPlanId()},
      { name: "Device", value: 'DEVICE',isAllowed:false /*to be determined*/ },
    ]
  const isCorporateAdmin = React.useMemo(() => authService.isCorporateSAASAdmin(), []);
  
  if (!showModal) return null;

  const styleClasses=useStyleClasses();
  const projectService=new ProjectService();

  React.useEffect(() => {
    fetchProjects();
    fetchAllKitTypes();

  }, [])

  useEffect(() => {
    loadGoogleMaps(environment.googleMapKey).catch(function (e) {
      console.error("Failed to load Google Maps", e);
    });
  }, []);

  const fetchProjects = async () => {
    const projectsAll = await ProjectService.getProjectsForUser();
    setProjectsAll(projectsAll.data.content)
    console.log('projects', projectsAll.data.content)
  }
  const fetchAllKitTypes = async () => {
    console.log('getting kit types');
    const response = await getAllKitTypes();
    console.log('types', response.content)
    const allowedTypes = ["TRUCK", "COLD_ROOM", "FREEZER"];
    const typesForPolarSAAS = response.content.filter(
      (type: { name: string }) => allowedTypes.includes(type.name)
    );
    setTypeOfKits(typesForPolarSAAS);
    console.log('kittYpes', typesForPolarSAAS);
  }

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      // if nested field
      if (name.includes(".")) {
        const [parent, child] = name.split(".");
        return {
          ...prev,
          [parent]: {
            ...prev[parent],
            [child]: value,
          },
        };
      }

      // flat field
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  // add new empty sensor to list
  const addSensor = () => {
    setSensorList([...sensorList, { id: `${sensorList.length}`, sensor: "" }]); // "" = not selected
  };

  // update sensor value at index i
  const handleSensorChange = (value, i) => {
    const updatedList = [...sensorList];
    updatedList[i].sensor = value;
    setSensorList(updatedList);
  };

  // remove sensor dropdown
  const removeSensor = (i) => {
    const updatedList = [...sensorList];
    updatedList.splice(i, 1);
    setSensorList(updatedList);
  };
  function handleFindMyLocation() {
    getCurrentLocation()
      .then(function (pos) {
        console.log('position fetched',pos)
        setFormData(function (prev) {
          return {
            ...prev,
            area: pos.address ? pos.address : prev.metaData.area,
            initialLocation: { lat: pos.lat, lng: pos.lng },
          };
        });

        setMyLoc({ lat: pos.lat, lng: pos.lng });
        setShowMapModal(true);
        console.log('location',myLoc)
      })
      .catch(function (err) {
        console.error("Unable to get location:", err);
        alert("Unable to get your location. Please allow location access.");
      });
  }

  function handleAreaChangeWithPredictions(
    e: React.ChangeEvent<HTMLInputElement>
  ) {
    var value = e.target.value;
    setFormData(function (prev) {
      return {
        ...prev,
        metaData: { ...prev.metaData, area: value },
        initialLocation: undefined as any,
      };
    });
    setAreaError("");

    if (!value || value.replace(/\s+/g, "").length < 3) {
      setPredictions([]);
      return;
    }
    console.log('getting place predictions', value)
    getPlacePredictions(value)
      .then(function (preds) {
        setPredictions(preds);
      })
      .catch(function () {
        setPredictions([]);
      });
  }

  function selectPrediction(p: any) {
    setFormData(function (prev) {
      return { ...prev, metaData: { ...prev.metaData, area: p.description } };
    });
    setPredictions([]);
    setAreaError("");
    geocodePlaceId(p.place_id)
      .then(function (coords) {
        setFormData(function (prev) {
          return { ...prev, initialLocation: coords };
        });
      })
      .catch(function (err) {
        console.warn("Geocode failed:", err);
        setAreaError("Could not fetch location for the selected address.");
      });
  }

  const validateStepOne = () => {
    let valid = true;
    const newErrors = {
      name: '',
      description: '',
      inputMethod: '',
      metaData: '',
      area: '',
      item: '',
      projectId: '',
      typeOfKit: '',
      sensorMap: '',
      storageCategory:'',
      id:""
    };
    

    // Entity Id validation
    if (!isAddKitSAAS && !formData.id.trim()) {
      newErrors.id = 'Entity id is required';
      valid = false;
    } else if (!isAddKitSAAS&&!/^[a-zA-Z0-9\s-_]+$/.test(formData.id.trim())) {
      newErrors.id = 'Entity id can only contain letters, numbers, spaces , underscores and hyphens';
      valid = false;
    }
    // Entity Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Entity name is required';
      valid = false;
    } else if (!/^[a-zA-Z0-9-]+$/.test(formData.name.trim())) {
      newErrors.name = 'Entity name can only contain letters, numbers, spaces and hyphens';
      valid = false;
    }

    // Entity Description validation
    if (!formData.description.trim()) {
      newErrors.description = 'Entity description is required';
      valid = false;
    }

    // Input Type validation
    if (isAddKitSAAS&&!formData.inputMethod) {
      newErrors.inputMethod = 'Please select an input type';
      valid = false;
    }

    // Area validation
    if (formData.metaData.area.trim().length > 0 && formData.initialLocation===undefined) {
      newErrors.area = 'Added address invalid. select address from dropdownlist or try with different keywords';
      valid = false;
    }


    // Project validation
    if (!formData.projectId) {
      newErrors.projectId = 'Project is required';
      valid = false;
    }

    console.log('validation kit', newErrors, valid)
    setErrors(newErrors);
    return valid;
  };

    const validateStepTwo = () => {
      let valid = true;
      const newErrors = {
        name: '',
        description: '',
        inputMethod: '',
        metaData: '',
        area: '',
        item: '',
        projectId: '',
        typeOfKit: '',
        sensorMap: '',
        storageCategory:'',
        id:''
      };

      // Type of Kits validation
      if (!formData.typeOfKit.trim()) {
        newErrors.typeOfKit = 'Type of kits is required';
        valid = false;
      }

      // Sensor Map validation
      if (sensorList.length === 0) {
        newErrors.sensorMap = 'Atleast one sensor is required';
        valid = false;
      }

      console.log('validation kit step 2', newErrors, valid)
      setErrors(newErrors);
      return valid;
    }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isAddKitSAAS && validateStepTwo()) {
      console.log('is valid', sensorList)
      const sensorMapObj: Record<string, string> = {};
      sensorList.forEach(sensor => {
        if (sensor.sensor !== '') {
          sensorMapObj[sensor.id] = sensor.sensor;
        }
      });

      console.log('sensor kit', sensorMapObj);
      const updatedFormData = {
      ...formData,
      sensorMap: sensorMapObj
      };
      setFormData(updatedFormData);
      //remove id
     const { id, ...finalData } = updatedFormData;
      await onCreateKit(finalData)
      handleClose();
    }
    else if(!isCorporateAdmin){
      if(currentStep===1 && validateStepOne()){
        const kitProject={name: formData.name,
                          id:formData.id,
                          description: formData.description,
      }
      if(formData.metaData.area.trim().length > 0 && formData.initialLocation!==undefined){
        kitProject['metaData']={area:formData.metaData.area,item:formData.metaData.item};
        kitProject['initialLocation']=formData.initialLocation;
      }
      try{
        setLoading(true);
      const response = await projectService.addKitToProject(formData.projectId,kitProject); 
      console.log('add kit response',response);
      if(response&&response.status==200){
        setLoading(false);
      handleClose();}
      }
      catch(err){
        setLoading(false);
       if(err.status==422 && err.message){
        setError(err.message);
      }
      else{
        setError("Error Adding Kit");
      }}

      
     
    }
  };
}

  const renderStepOne = () => (
    <div>
      {/* Project */}
      { <div className="form-group" style={{ padding: "0 0" }}>
        <label htmlFor="project" style={styleClasses.label}>
          Project <span style={{ color: "#ef4444" }}>*</span>
        </label>
        <select
          id="projectId"
          name="projectId"
          value={formData.projectId}
          onChange={handleInputChange}
          style={styleClasses.input}
        >
          <option value="">Select project</option>
          {projectsAll.map(project => (
            <option key={project.id} value={project.id}>{project.name}</option>
          ))}
        </select>
              {errors.projectId && <span style={styleClasses.errorText}>{errors.projectId}</span>}
      </div>}

      {/* Entity Name and Entity ID */}
      <div className="form-group" style={{  paddingBottom: "0px" }}>
        <div style={{ flex: 1 }}>
          <label htmlFor="name" style={styleClasses.label}>
            Entity Name <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter entity name here"
            value={formData.name}
            onChange={handleInputChange}
            style={styleClasses.input}
          />
        </div>
              {errors.name && <span style={styleClasses.errorText}>{errors.name}</span>}
      </div>
      {!isAddKitSAAS &&
            <div className="form-group" style={{  paddingBottom: "0px" }}>
        <div style={{ flex: 1 }}>
          <label htmlFor="kitId" style={styleClasses.label}>
            Entity Id <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <input
            type="text"
            id="id"
            name="id"
            placeholder="Enter entity id here"
            value={formData.id}
            onChange={handleInputChange}
            style={styleClasses.input}
          />
        </div>
              {errors.id && <span style={styleClasses.errorText}>{errors.id}</span>}
      </div>}

      {/* Entity Description */}
      <div className="form-group" style={{ paddingBottom: "0" }}>
        <label htmlFor="description" style={styleClasses.label}>
          Entity Description <span style={{ color: "#ef4444" }}>*</span>
        </label>
        <textarea
          id="description"
          name="description"
          placeholder="Enter entity description here"
          rows={3}
          value={formData.description}
          onChange={handleInputChange}
          style={{
            ...styleClasses.input
          }}
        />
          {errors.description && <span style={styleClasses.errorText}>{errors.description}</span>}
      </div>

      {/* Input Type */}
      {isAddKitSAAS &&
      
      <div className="form-group" style={{ paddingBottom: "0" }}>
        <label style={styleClasses.label}>
          Input Method <span style={{ color: "#ef4444" }}>*</span>
        </label>
        <div style={{ display: "flex", gap: "24px" }}>
          {inputMethods.map(method => (
            <label style={{ display: "flex", alignItems: "center", gap: "8px", ...styleClasses.baseFont ,color:method.isAllowed?'black':'gray' }}>
              <input
                type="radio"
                name="inputMethod"
                value={method.value}
                checked={formData.inputMethod === method.value}
                onChange={handleInputChange}
                style={{ margin: 0 }}
                disabled={!method.isAllowed}
              />
              {method.name}
            </label>))}
        </div>
        {errors.inputMethod && <span style={{
          color: '#EF4444',
          fontSize: '12px',
          marginTop: '4px',
          display: 'block',
        }}>{errors.inputMethod}</span>}
      </div>
      }

      {/* Area/Location */}
      <div className="form-group" style={{ paddingBottom: "0" }}>
        <label htmlFor="area" style={styleClasses.label}>
          Location 
        </label>

        <div
          className="search-containar"
          style={{ position: "relative" }}
        >
          <input
            type="text"
            id="area"
            name="area"
            className="form-input search-input-react"
            placeholder="Search an address..."
            value={formData.metaData.area}
            onChange={handleAreaChangeWithPredictions} // << use the new handler
            autoComplete="off"
          />

          {predictions.length > 0 && (
            <div
              className="dropdown-menu"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                zIndex: 1000,
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                marginTop: 6,
                maxHeight: 240,
                overflowY: "auto",
              }}
            >
              {predictions.map(function (p) {
                return (
                  <div
                    key={p.place_id}
                    className="dropdown-item"
                    onClick={function () {
                      selectPrediction(p);
                    }}
                    style={{
                      padding: "10px 12px",
                      cursor: "pointer",
                    }}
                  >
                    {p.description}
                  </div>
                );
              })}
            </div>
          )}

          {/* <button
            type="button"
            className="location-btn"
            onClick={handleFindMyLocation}
          >
            <img
              src={locationIcon}
              width="16"
              height="16"
              alt=""
              className="location-icon"
              style={{
                display: "inline-block",
                verticalAlign: "middle",
              }}
            />{" "}
            Find My Current Location
          </button> */}
        </div>
        {errors.area && <span style={{
          color: '#EF4444',
          fontSize: '12px',
          marginTop: '4px',
          display: 'block',
        }}>{errors.area}</span>}
      </div>

      {/* Item */}
      <div className="form-group" style={{ paddingBottom: "0" }}>
        <label htmlFor="item" style={styleClasses.label}>
          Item
        </label>
        <input
          type="text"
          id="item"
          name="metaData.item"
          placeholder="Enter item here"
          value={formData.metaData.item}
          onChange={handleInputChange}
          style={styleClasses.input}
        />
      </div>
    </div>
  );

  const renderStepTwo = () => (
    <>
      {/* Type */}
      <div className="form-group" style={{ paddingBottom: "20px" }}>
        <label htmlFor="type" style={styleClasses.label}>
          Type of Entity <span style={{ color: "#ef4444" }}>*</span>
        </label>
        <select
          id="type"
          name="typeOfKit"
          value={formData.typeOfKit}
          onChange={handleInputChange}
          style={styleClasses.input}
        >
          <option value="">Select type</option>
          {typeOfKits.map(type => (
            <option value={type.value}>{type.name}</option>
          ))}
        </select>
        {errors.typeOfKit && <span style={{
            color: '#EF4444',
            fontSize: '12px',
            marginTop: '4px',
            display: 'block',
          }}>{errors.typeOfKit}</span>}
      </div>

      {/* Brand/Model and Storage Category in same line */}
      <div style={{ display: "flex", gap: "16px", paddingBottom: "20px" }}>
        <div style={{ flex: 1 }}>
          <label htmlFor="brandModel" style={styleClasses.label}>
            Brand / Model (Optional)
          </label>
          <input
            type="text"
            id="brandModel"
            name="brandModel"
            placeholder="Enter brand / model here"
            value={formData.brandModel}
            onChange={handleInputChange}
            style={styleClasses.input}
          />
        </div>
        <div style={{ flex: 1 }}>
          <label htmlFor="storageCategory" style={styleClasses.label}>
            Storage Category <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <select
            id="storageCategory"
            name="storageCategory"
            value={formData.storageCategory}
            onChange={handleInputChange}
            style={styleClasses.input}
          >
            <option value="">Select storage category</option>
            <option value="meat-storage">Meat storage</option>
            <option value="vaccine-preservation">Vaccine preservation</option>
          </select>
        </div>
        {errors.storageCategory && <span style={{
            color: '#EF4444',
            fontSize: '12px',
            marginTop: '4px',
            display: 'block',
          }}>{errors.storageCategory}</span>}
      </div>



      {/* Configure Sensor Type in Order */}
      <div className="form-group" style={{ paddingBottom: "0" }}>
        <label style={{ ...styleClasses.label, marginBottom: "16px" }}>
          Configure Sensor Type in Order <span style={{ color: "#ef4444" }}>*</span>
        </label>

        <div
          style={{
            maxHeight: "125px",
            overflowY: "auto",
            border: "1px solid #e5e7eb",
            borderRadius: "4px",
            padding: "8px",
          }}
        >
          {sensorList.map((sensor, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "8px",
              }}
            >
              <div style={{ width: "24px", textAlign: "center" }}>{i + 1}</div>

              <select
                id={`${i}`}
                name="sensor"
                value={sensor.sensor}
                onChange={(e) => handleSensorChange(e.target.value, i)}
                style={{ ...styleClasses.input, flex: 1 }}
              >
                <option value="">Select Sensor</option>
                {sensors.map((s) => (
                  <option key={s.code} value={s.code}>
                    {s.codeValue}
                  </option>
                ))}
              </select>

              <button
                onClick={() => removeSensor(i)}
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e5e7eb",
                  borderRadius: "2px",
                  background: "#f87171",
                  color: "white",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        <button style={styleClasses.button} onClick={addSensor}>+ Add Sensor</button>
        {errors.sensorMap && <span style={styleClasses.errorText}>{errors.sensorMap}</span>}
      </div>
    </>
  );

  const handleNext = () => {
    if(validateStepOne()){
    setCurrentStep(2);
    }
  };

  const handleBack = () => {
    setCurrentStep(1);
  };

  return (
    <div
      className="model-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        ...styleClasses.baseFont
      }}
    >
      <div
        className="model"
        onClick={(e) => e.stopPropagation()}
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "90vh",
          width: "700px",
          backgroundColor: "white",
          overflow: "hidden",
          ...styleClasses.baseFont
        }}
      >
        {/* Header - fixed */}
        <div
          className="model-header"
          style={{
            flexShrink: 0,
            padding: "16px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="model-title" style={styleClasses.formHeader}>
            ADD KITS
          </h2>
          <button
            className="close-btn"
            onClick={handleClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              ...styleClasses.baseFont
            }}
          >
            ×
          </button>
        </div>

        {/* Progress Steps - fixed */}
        {isAddKitSAAS && (
        <div style={{
          padding: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          ...styleClasses.baseFont
        }}>
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            ...styleClasses.baseFont
          }}>
            <div style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: currentStep === 1 ? "white" : "#2A7CED",
              border: "2px solid #2A7CED",
              color: currentStep === 1 ? "#2A7CED" : "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              fontWeight: 500,
              ...styleClasses.baseFont
            }}>
              01
            </div>
            <span style={{
              fontSize: "14px",
              color: "#2A7CED",
              fontWeight: 500,
              ...styleClasses.baseFont
            }}>
              Step 01
            </span>
          </div>
          <div style={{
            width: "150px",
            height: "2px",
            backgroundColor: "#e5e7eb"
          }}></div>
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
            ...styleClasses.baseFont
          }}>
            <div style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: currentStep === 2 ? "#2A7CED" : "white",
              border: "2px solid #2A7CED",
              color: currentStep === 2 ? "white" : "#2A7CED",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              fontWeight: 500,
              ...styleClasses.baseFont
            }}>
              02
            </div>
            <span style={{
              fontSize: "14px",
              color: currentStep === 2 ? "#2A7CED" : "#707e91",
              fontWeight: 500,
              ...styleClasses.baseFont
            }}>
              Step 02
            </span>
          </div>
        </div>)}

        {/* Form Content - scrollable */}
        <div
          className="model-body"
          style={{
            overflowY: "auto",
            padding: "24px",
            flexGrow: 1,
            ...styleClasses.baseFont
          }}
        >
           {error&&error.length>0 && <div style={{
            backgroundColor: 'rgba(174, 91, 91, 0.1)' ,
            padding: '8px',
            borderRadius: '4px',
            marginBottom: '12px',
           }}><span style={{
              color: '#f30808ff',
              fontSize: '12px',
              marginTop: '4px',
              display: 'block',
            }}>{error}</span>
          </div>}
          {currentStep === 1  ? renderStepOne() : renderStepTwo()}
        </div>

        {/* Footer with action buttons - fixed */}
        <div
          className="model-footer"
          style={styleClasses.buttonEndContainer}
        >
          {currentStep === 2 ? (
            <button
              onClick={handleBack}
              style={styleClasses.buttonBack}
            >
              Back
            </button>
          ) : (
            <button
              onClick={handleClose}
              style={styleClasses.buttonBack}
            >
              Cancel
            </button>
          )}

          {(currentStep === 1 && isAddKitSAAS) ?
            <button
              onClick={handleNext}
              style={styleClasses.buttonSubmit}
            >
                Next

            </button>
           : (
         
          <button
            onClick={handleSubmit}
            style={styleClasses.buttonSubmit}
          >
              Add Entity
            </button>
          )}
        </div>
      </div>
      <Loader isLoading={loading} fullScreen={true}/>
    </div>
  );
};

export default AddKitModal;
